<template>
  <vs-card>
    <main>
      <div class="heading">
        <div>
          <h4>Calendar</h4>
          <p class="current-date">{{ formattedCurrentDate }}</p>
        </div>
        <div>
          <vs-select :color="colorx" label="Language Filter" v-model="select.language" @change="fetchData">
            <vs-select-item v-for="(item, index) in languages" :key="index" :value="item.culture" :text="item.label" />
          </vs-select>
        </div>
      </div>

      <div class="month-navigation">
        <button @click="previousMonth" style="padding: 4px; border-radius: 5px">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 6L9 12L15 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Previous
        </button>
        <button @click="nextMonth" style="padding: 4px; border-radius: 5px">
          Next
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <div v-if="loading" class="loading-indicator">Loading...</div>

      <div v-else>
        <div class="grid-container weekdays">
          <div class="weekday-box" v-for="(day, index) in weekDays" :key="index" :class="{ 'monday-bg': day === 'Monday' }">
            <div>{{ day }}</div>
            <div>
              <span>{{ t(selectedTranslation.labels[day.toLowerCase()]) }}</span>
            </div>
          </div>
        </div>

        <div class="grid-container days">
          <div v-for="i in adjustedStartDate" :key="'empty-' + i" class="day-box empty"></div>

          <div v-for="(day, index) in daysInMonth" :key="day" class="day-grid" :class="[dayClass(day), getEventcount(day)]">
            <div v-if="panchangData">
              <div class="panchang-details">
                <div class="panchang-info">
                  <div class="grid-info">
                    <div class="event-info">
                      <div>
                        <div
                          v-if="getFestivalscount(day).festivalCount > 0"
                          class="cursor festival"
                          @click="
                            showFestivalsModal = true;
                            festivalsModal(day);
                          "
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 128 128"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            aria-hidden="true"
                            role="img"
                            class="iconify iconify--noto"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <path
                              d="M56.1 81.32c-.6.24-52.2.39-52.2.39s-1.02 6.57 2.98 15.1c2.7 5.75 7.07 13.65 12.75 18.35c3.46 2.86 10.84 9.29 29.55 9.41c20.38.13 28.12-9.18 32.53-13.35s10.61-12.99 15.13-17.4s9.41-7.39 9.77-11.56c.36-4.17-2.74-4.29-2.74-4.29L56.1 81.32z"
                              fill="#891e0d"
                            ></path>
                            <path
                              d="M48.95 106.82c20.49-.82 27.29-8.1 40.99-16.33c11.74-7.04 16.21-9.65 16.21-11.44s-10.79-5.11-17.04-7.98c-8.82-4.05-21.81-11.8-44.69-11.92c-19.67-.1-40.56 7.87-40.56 23.12c.01 15.49 25.32 25.34 45.09 24.55z"
                              fill="#d75010"
                            ></path>
                            <path
                              d="M35.79 67.38l-9.91 2.34l-10.66 6.08l-1.17 6.82l1.81 2.98l66.29.96l9.06-6.29s-3.52-1.81-4.16-2.24c-.64-.43-24.3-8.42-24.62-8.31c-.32.11-26.64-2.34-26.64-2.34z"
                              fill="#fe9700"
                            ></path>
                            <path
                              d="M15.54 86.99s.85-3.75 5.33-7.14c4.37-3.3 11.34-6.55 25.21-5.89c12.77.61 22.32 5.03 26.9 8.02c4.58 2.98 7.99 5.44 7.99 5.44l-13.32 6.82l-16.52 4.16s-23.34-2.34-24.41-3.3c-1.06-.97-11.18-8.11-11.18-8.11z"
                              fill="#d85f11"
                            ></path>
                            <path
                              d="M26.07 93.72s-.07-.05-.18-.18c-.37-.46-1.24-3.11-.68-5.79c1.19-5.63 6.82-8.71 11.85-9.57c6.13-1.05 11.73-.94 11.73 3.44c0 3.52-4.94 3.18-7.39 3.41c-2.44.23-6.02.91-6.14 3.41c-.12 2.62 4.29 3.76 11.31 2.95c6.15-.71 15.1-3.8 15.1-3.8l3.43 4.37l-.4 3.13s-9.83 2.95-10.34 2.9c-.51-.06-17.84-.11-18.81-.57c-.96-.46-9.48-3.7-9.48-3.7z"
                              fill="#eba961"
                            ></path>
                            <path
                              d="M48.2 99.26c-2.47 0-5.12-.12-8.02-.37c-13.89-1.2-30.17-8.17-27.98-18.06c1.93-8.72 13.68-14.91 32.82-14.95c20.26-.04 46.25 12.5 47.35 13.01c0 0 1.07.43 1.14 1.11c.07.75-.84 1.42-.84 1.42c-.32.26-8.02 6.39-19.13 11.89c-7.32 3.63-14.47 5.95-25.34 5.95zm-5.01-30.39c-16.75 0-27.39 6.03-27.82 12.4c-.53 7.83 12.67 13.56 25.07 14.63c15.03 1.3 23.03-.95 31.77-5.28c7.57-3.75 13.62-7.88 16.58-10.04c-6.84-2.97-27.61-11.39-43.83-11.7c-.59-.01-1.19-.01-1.77-.01z"
                              fill="#ffe36a"
                            ></path>
                            <path
                              d="M61.67 87.58s6.38-2.51 10.58-4.5c4.05-1.92 11.45-6.37 11.45-6.37l6.78.81l3.02 2.49s-9.43 6.43-17.4 9.97c-6.61 2.94-12.61 4.2-12.61 4.2s-3.73-.02-3.83-3.17c-.06-2.21 2.01-3.43 2.01-3.43z"
                              fill="#fef499"
                            ></path>
                            <path
                              d="M4.86 80.61c-.06 1.44 1.22 2.44 3.27 2.33c1.78-.1 3-.93 2.94-2.44c-.06-1.39-1.03-2.34-2.88-2.33c-2.11 0-3.27.98-3.33 2.44z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M15.83 91.57c-1.33-.1-3.22.78-3.11 2.88s2.22 2.55 3.33 2.44c1.21-.12 2.59-.78 2.72-2.5c.11-1.43-.67-2.65-2.94-2.82z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M34.12 99.27c-1.5-.02-3.24.89-3.24 2.68c0 1.62 1.47 2.61 3.49 2.64c1.96.03 3.19-1.14 3.15-2.71c-.02-1.11-.82-2.58-3.4-2.61z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M55.31 99.95c-2.29.22-3.27 1.6-3.17 2.93c.1 1.33 1.29 2.5 3.52 2.28c2.62-.25 3.22-1.39 3.16-2.69s-1.08-2.75-3.51-2.52z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M72.89 94.55c-1.58.72-2.25 2.24-1.5 3.55c.65 1.14 2.66 1.03 3.91.23c1.24-.8 1.92-1.97 1.24-3.31c-.59-1.15-2.15-1.15-3.65-.47z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M85.99 89.64c.98 1.32 2.51.85 3.72-.03c1.18-.86 1.56-2.18.95-3.19c-.62-1.01-2.18-1.01-3.55-.1s-1.87 2.31-1.12 3.32z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M96.81 81.61c.88.95 2.43.9 3.72.07c1.4-.91 1.63-2.22.75-2.84s-2.16-.64-3.42.03c-.73.39-1.96 1.76-1.05 2.74z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M66.15 65.25c-.46 1.21-.26 2.64 2.02 3.19c2.28.55 3.21-.48 3.42-1.47c.26-1.21-.59-2.41-2.18-2.74c-1.6-.31-2.86-.03-3.26 1.02z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M47.5 62.28c-.15 1.19.59 2.31 2.93 2.51s3.29-.63 3.37-2.09c.09-1.69-1.61-2.19-3.1-2.34c-1.57-.16-3.02.47-3.2 1.92z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M30.19 63.49c.09 1.18 1.26 2.08 3.22 1.79c1.96-.29 2.77-1.27 2.56-2.56c-.21-1.28-1.52-1.93-3.07-1.8c-1.6.12-2.82 1.13-2.71 2.57z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M15.81 66.62c-1.59.66-1.92 2.84-.65 3.59s2.97.73 4.2-.23c1.46-1.14 1.31-2.76.2-3.35c-1.19-.64-2.4-.57-3.75-.01z"
                              fill="#ffa821"
                            ></path>
                            <path
                              d="M8.45 74.38c.34 1.22 1.43 1.83 3.35 1.42c1.75-.37 2.68-1.56 2.43-2.87c-.26-1.31-1.48-2.13-3.45-1.68c-1.92.44-2.65 1.99-2.33 3.13z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M6.74 88.08c.08 1.6 1.36 2.56 2.92 2.56c1.63 0 2.95-1 2.91-2.59c-.05-1.71-1.21-2.44-2.93-2.48c-1.2-.02-3 .56-2.9 2.51z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M21.19 98.67c-.09 1.87 1.38 2.87 3.17 2.87s2.96-.88 3.05-2.67c.1-1.79-1.36-2.59-3.09-2.62c-1.72-.04-3.05.68-3.13 2.42z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M41.68 102.82c.06 1.5 1.38 2.49 3.33 2.55c1.99.07 3.47-.89 3.48-2.78c.01-1.52-1.4-2.55-3.52-2.55c-1.96 0-3.36 1.09-3.29 2.78z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M62.07 101.66c.53 1.51 2.22 1.76 4.17 1.08c1.96-.68 2.66-2.35 2.25-3.49c-.52-1.43-2.31-1.73-3.95-1.24c-1.63.49-3.12 1.79-2.47 3.65z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M80.37 90.47c-1.23.76-1.92 2.15-1.17 3.36s2.54.91 3.61.16c1.18-.82 1.99-2.18 1.08-3.39c-.98-1.29-2.57-.71-3.52-.13z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M92.86 82.66c-1.23.74-1.57 2.15-.78 3.12c.74.91 2.35.69 3.3.04c.95-.65 1.53-2.14.49-3.13c-.77-.74-2.02-.62-3.01-.03z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M73.92 67.48c-.72 1.47.26 2.74 1.63 3.26c1.37.52 2.61.03 3.03-.78s.16-2.31-1.6-3c-1.75-.69-2.77-.07-3.06.52z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M56.83 63.43c-.23 1.7.9 2.53 2.72 2.76c1.78.22 3.17-.28 3.43-1.86c.26-1.6-1.14-2.44-2.51-2.74c-1.38-.29-3.43.25-3.64 1.84z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M38.56 62.39c0 1.4 1.3 2.23 3.11 2.19c1.99-.04 3.07-.77 3.06-2.23c-.01-1.31-1.29-2.26-3.1-2.26c-1.86 0-3.07 1.04-3.07 2.3z"
                              fill="#91c354"
                            ></path>
                            <path
                              d="M24.1 63.05c-2.37.47-2.23 2.13-1.89 2.98c.39.98 1.75 1.5 3.22 1.19c1.97-.41 2.64-1.83 2.18-2.87c-.54-1.24-1.94-1.61-3.51-1.3z"
                              fill="#91c354"
                            ></path>
                            <radialGradient id="IconifyId17ecdb2904d178eab7797" cx="93.645" cy="9.376" r="57.576" gradientUnits="userSpaceOnUse">
                              <stop offset=".418" stop-color="#ffcf18"></stop>
                              <stop offset=".601" stop-color="#ffcc16"></stop>
                              <stop offset=".744" stop-color="#fec212"></stop>
                              <stop offset=".873" stop-color="#fdb10a"></stop>
                              <stop offset=".982" stop-color="#fc9d00"></stop>
                            </radialGradient>
                            <path
                              d="M93.71 8.97c-1.34 0-3.48 9.38-5.76 15.94c-2.28 6.56-8.74 23.44-10.58 31.62c-1.21 5.36-1.35 12.63 1.43 16.7c2.29 3.36 7.17 6.67 12.43 7.18c5.6.54 15.62-2.58 17.76-11.42c2.14-8.84-1.07-17.28-3.35-24.79c-1.82-6-5.09-14.74-6.7-20.1c-1.2-3.95-3.89-15.13-5.23-15.13z"
                              fill="url(#IconifyId17ecdb2904d178eab7797)"
                            ></path>
                            <path
                              d="M87.34 71.14s-.79 1.68-1.53 2.72c-.93 1.31-2.79 3.36-2.79 3.36s.53.57 2.77 1.67c4.57 2.24 8.09 1.54 8.09 1.54s1.57-1.88 2.01-3.02s.22-3.92-3.16-5.61c-3.37-1.69-5.11-1.26-5.39-.66z"
                              fill="#ff7512"
                            ></path>
                            <path
                              d="M89.36 75.34s2.78-.11 4.09.33S96 76.81 96 76.81s.49-2.83-2.89-5.28s-5.45-.82-5.45-.82s.65 1.04.93 1.96c.28.92.77 2.67.77 2.67z"
                              fill="#ca750f"
                            ></path>
                            <radialGradient
                              id="IconifyId17ecdb2904d178eab7798"
                              cx="91.377"
                              cy="51.143"
                              r="49.412"
                              gradientTransform="matrix(.0162 -.9999 .741 .012 52.002 141.895)"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset=".184" stop-color="#ffd874"></stop>
                              <stop offset="1" stop-color="#ffd874" stop-opacity="0"></stop>
                            </radialGradient>
                            <path
                              d="M53.35 47.45c-1.92 26.39 6.83 55.92 40.17 54.81c33.33-1.11 34.71-27.2 34.3-52.81C127.42 24.33 122.71.99 94.7.32C70.24-.26 55.35 19.88 53.35 47.45z"
                              opacity=".5"
                              fill="url(#IconifyId17ecdb2904d178eab7798)"
                            ></path>
                          </svg>
                          <span class="festival-more">
                            Festivals:
                            {{ getFestivalscount(day).festivalCount }}
                          </span>
                        </div>
                        <div>
                          <vs-popup :active.sync="showFestivalsModal" :title="'Festivals on ' + currentDay">
                            <div class="popup-content">
                              <div class="list">
                                <ol>
                                  <li
                                    v-for="(festival, index) in festivalsForDay"
                                    :key="festival.id"
                                    @click="redirectToFestivals(festival._id)"
                                    class="cursor"
                                  >
                                    {{ festival.name }}:

                                    <template v-if="festival.matchedStart && festival.matchedEnd">
                                      From: ({{ formatDatetime(festival.matchedStart) }}) To: ({{ formatDatetime(festival.matchedEnd) }})
                                    </template>

                                    <hr class="line" v-if="index < festivalsForDay.length - 1" />
                                  </li>
                                </ol>
                              </div>
                            </div>
                          </vs-popup>
                        </div>
                      </div>
                      <div>
                        <div @click="openEventModal(day)" v-if="getEventcount(day) > 0" class="cursor">
                          <svg
                            height="20"
                            width="20"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                          >
                            <circle style="fill: #ff7069" cx="256" cy="256" r="256" />
                            <path
                              style="fill: #e4e7ed"
                              d="M208.809,445.312l-24.051-129.184l-64.137,23.322l46.463,119.527 C171.274,469.546,211.906,459.707,208.809,445.312z"
                            />
                            <polygon style="fill: #c6cbd6" points="186.215,324.327 184.757,315.946 120.438,339.268 124.447,349.29 " />
                            <path
                              style="fill: #e4e7ed"
                              d="M227.576,283.695l196.054,12.208L329.794,58.124L195.143,201.338 c12.026,30.611,20.407,51.747,32.615,82.175L227.576,283.695z"
                            />
                            <polygon style="fill: #c6cbd6" points="227.576,283.695 423.63,295.903 415.248,274.585 223.932,274.585 " />
                            <g>
                              <path
                                style="fill: #6c7678"
                                d="M198.058,203.16c-2.186-5.466-7.47-8.746-11.661-6.924L73.976,241.059 c-4.373,1.64-6.013,7.653-3.826,13.119l16.399,41.543l16.399,41.361c2.186,5.466,7.47,8.746,11.661,6.924l112.421-44.823 c4.373-1.64,6.013-7.653,3.826-13.119l-16.399-41.361L198.058,203.16z"
                              />
                              <path
                                style="fill: #6c7678"
                                d="M434.198,290.073c2.004,5.102,0.182,10.75-4.373,12.572l0,0c-4.373,1.822-9.657-0.911-11.661-6.195 L325.238,61.404c-2.004-5.102-0.182-10.75,4.373-12.572l0,0c4.373-1.822,9.657,1.093,11.661,6.195L434.198,290.073z"
                              />
                            </g>
                            <path style="fill: #e4e7ed" d="M98.938,327.243l-25.873-65.23C26.42,274.403,46.827,348.743,98.938,327.243z" />
                            <path
                              style="fill: #ffe356"
                              d="M435.838,148.68l-33.89,13.301c-2.004,0.729-2.733,3.644-1.64,6.377 c1.093,2.733,3.644,4.373,5.648,3.644l33.89-13.301c2.004-0.729,2.733-3.644,1.64-6.377 C440.393,149.591,437.842,147.952,435.838,148.68z"
                            />
                            <path
                              style="fill: #6c7678"
                              d="M166.172,456.974l42.636-10.932c6.195-1.64,9.11,10.021,2.915,11.661L169.27,468.27 c-5.831,1.458-8.928-9.657-3.28-11.115L166.172,456.974z"
                            />
                            <g>
                              <path
                                style="fill: #ffe356"
                                d="M401.583,82.54l-21.865,29.153c-1.275,1.64-0.364,4.555,2.004,6.377 c2.369,1.822,5.284,1.822,6.559,0.182l21.865-29.153c1.275-1.64,0.364-4.555-2.004-6.377C405.774,80.9,402.858,80.9,401.583,82.54z"
                              />
                              <path
                                style="fill: #ffe356"
                                d="M458.978,229.762l-35.712-6.742c-2.004-0.364-3.28-3.098-2.733-6.013 c0.547-2.915,2.733-4.92,4.737-4.555l35.712,6.742c2.004,0.364,3.28,3.098,2.733,6.013 C463.169,228.122,460.982,230.127,458.978,229.762z"
                              />
                            </g>
                            <path
                              style="fill: #e4e7ed"
                              d="M90.374,245.25c-1.458,0.547-3.28-0.182-3.826-1.64c-0.547-1.458,0.182-3.28,1.64-3.826l76.891-29.7 c1.458-0.547,3.28,0.182,3.826,1.64c0.547,1.458-0.182,3.28-1.64,3.826L90.374,245.25z"
                            />
                          </svg>
                          <span style="font-size: 13px; margin-left: 4px">Events: {{ getEventcount(day) }}</span>
                        </div>
                        <vs-popup :active.sync="showEventModal" :title="'Events on ' + currentEventDay">
                          <div class="popup-content">
                            <div class="list">
                              <ol>
                                <li v-for="event in eventsForDay" @click="redirectToEvents(event._id, event.title)" :key="event.id" class="cursor">
                                  {{ event.title }}- From: ({{ formatDate(event.startDate) }}) {{ event.startTime }} - To: ({{
                                    formatDate(event.endDate)
                                  }}) {{ event.endTime }}
                                  <hr class="line" v-if="index < eventsForDay.length - 1" />
                                </li>
                              </ol>
                            </div>
                          </div>
                        </vs-popup>
                      </div>
                      <div>
                        <div
                          @click="
                            showBhaktiModal = true;
                            bhaktiModal(day);
                          "
                          v-if="getBhakticount(day) > 0"
                          class="cursor"
                        >
                          <svg
                            height="20"
                            width="20"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                          >
                            <circle style="fill: #ff7069" cx="256" cy="256" r="256" />
                            <path
                              style="fill: #e4e7ed"
                              d="M208.809,445.312l-24.051-129.184l-64.137,23.322l46.463,119.527 C171.274,469.546,211.906,459.707,208.809,445.312z"
                            />
                            <polygon style="fill: #c6cbd6" points="186.215,324.327 184.757,315.946 120.438,339.268 124.447,349.29 " />
                            <path
                              style="fill: #e4e7ed"
                              d="M227.576,283.695l196.054,12.208L329.794,58.124L195.143,201.338 c12.026,30.611,20.407,51.747,32.615,82.175L227.576,283.695z"
                            />
                            <polygon style="fill: #c6cbd6" points="227.576,283.695 423.63,295.903 415.248,274.585 223.932,274.585 " />
                            <g>
                              <path
                                style="fill: #6c7678"
                                d="M198.058,203.16c-2.186-5.466-7.47-8.746-11.661-6.924L73.976,241.059 c-4.373,1.64-6.013,7.653-3.826,13.119l16.399,41.543l16.399,41.361c2.186,5.466,7.47,8.746,11.661,6.924l112.421-44.823 c4.373-1.64,6.013-7.653,3.826-13.119l-16.399-41.361L198.058,203.16z"
                              />
                              <path
                                style="fill: #6c7678"
                                d="M434.198,290.073c2.004,5.102,0.182,10.75-4.373,12.572l0,0c-4.373,1.822-9.657-0.911-11.661-6.195 L325.238,61.404c-2.004-5.102-0.182-10.75,4.373-12.572l0,0c4.373-1.822,9.657,1.093,11.661,6.195L434.198,290.073z"
                              />
                            </g>
                            <path style="fill: #e4e7ed" d="M98.938,327.243l-25.873-65.23C26.42,274.403,46.827,348.743,98.938,327.243z" />
                            <path
                              style="fill: #ffe356"
                              d="M435.838,148.68l-33.89,13.301c-2.004,0.729-2.733,3.644-1.64,6.377 c1.093,2.733,3.644,4.373,5.648,3.644l33.89-13.301c2.004-0.729,2.733-3.644,1.64-6.377 C440.393,149.591,437.842,147.952,435.838,148.68z"
                            />
                            <path
                              style="fill: #6c7678"
                              d="M166.172,456.974l42.636-10.932c6.195-1.64,9.11,10.021,2.915,11.661L169.27,468.27 c-5.831,1.458-8.928-9.657-3.28-11.115L166.172,456.974z"
                            />
                            <g>
                              <path
                                style="fill: #ffe356"
                                d="M401.583,82.54l-21.865,29.153c-1.275,1.64-0.364,4.555,2.004,6.377 c2.369,1.822,5.284,1.822,6.559,0.182l21.865-29.153c1.275-1.64,0.364-4.555-2.004-6.377C405.774,80.9,402.858,80.9,401.583,82.54z"
                              />
                              <path
                                style="fill: #ffe356"
                                d="M458.978,229.762l-35.712-6.742c-2.004-0.364-3.28-3.098-2.733-6.013 c0.547-2.915,2.733-4.92,4.737-4.555l35.712,6.742c2.004,0.364,3.28,3.098,2.733,6.013 C463.169,228.122,460.982,230.127,458.978,229.762z"
                              />
                            </g>
                            <path
                              style="fill: #e4e7ed"
                              d="M90.374,245.25c-1.458,0.547-3.28-0.182-3.826-1.64c-0.547-1.458,0.182-3.28,1.64-3.826l76.891-29.7 c1.458-0.547,3.28,0.182,3.826,1.64c0.547,1.458-0.182,3.28-1.64,3.826L90.374,245.25z"
                            />
                          </svg>
                          <span style="font-size: 13px; margin-left: 4px">Bhakti Promo: {{ getBhakticount(day) }}</span>
                        </div>
                        <div>
                          <vs-popup :active.sync="showBhaktiModal" :title="'Bhakti Promotion on ' + currentbhaktiDay">
                            <div class="popup-content">
                              <div class="list">
                                <ol>
                                  <li v-for="bhakti in bhaktiForDay" :key="bhakti._id" @click="redirectToBhaktiPromotion(bhakti._id)" class="cursor">
                                    {{ bhakti.title }}- From: ({{ formatDate(bhakti.start_date) }}) To: ({{ formatDate(bhakti.end_date) }})
                                    <hr class="line" v-if="index < bhaktiForDay.length - 1" />
                                  </li>
                                </ol>
                              </div>
                            </div>
                          </vs-popup>
                        </div>
                      </div>
                      <div>
                        <div
                          @click="
                            showNotificationModal = true;
                            notificationModal(day);
                          "
                          v-if="getNotificationcount(day) > 0"
                          class="cursor"
                        >
                          <svg
                            height="20"
                            width="20"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                          >
                            <circle style="fill: #ff7069" cx="256" cy="256" r="256" />
                            <path
                              style="fill: #e4e7ed"
                              d="M208.809,445.312l-24.051-129.184l-64.137,23.322l46.463,119.527 C171.274,469.546,211.906,459.707,208.809,445.312z"
                            />
                            <polygon style="fill: #c6cbd6" points="186.215,324.327 184.757,315.946 120.438,339.268 124.447,349.29 " />
                            <path
                              style="fill: #e4e7ed"
                              d="M227.576,283.695l196.054,12.208L329.794,58.124L195.143,201.338 c12.026,30.611,20.407,51.747,32.615,82.175L227.576,283.695z"
                            />
                            <polygon style="fill: #c6cbd6" points="227.576,283.695 423.63,295.903 415.248,274.585 223.932,274.585 " />
                            <g>
                              <path
                                style="fill: #6c7678"
                                d="M198.058,203.16c-2.186-5.466-7.47-8.746-11.661-6.924L73.976,241.059 c-4.373,1.64-6.013,7.653-3.826,13.119l16.399,41.543l16.399,41.361c2.186,5.466,7.47,8.746,11.661,6.924l112.421-44.823 c4.373-1.64,6.013-7.653,3.826-13.119l-16.399-41.361L198.058,203.16z"
                              />
                              <path
                                style="fill: #6c7678"
                                d="M434.198,290.073c2.004,5.102,0.182,10.75-4.373,12.572l0,0c-4.373,1.822-9.657-0.911-11.661-6.195 L325.238,61.404c-2.004-5.102-0.182-10.75,4.373-12.572l0,0c4.373-1.822,9.657,1.093,11.661,6.195L434.198,290.073z"
                              />
                            </g>
                            <path style="fill: #e4e7ed" d="M98.938,327.243l-25.873-65.23C26.42,274.403,46.827,348.743,98.938,327.243z" />
                            <path
                              style="fill: #ffe356"
                              d="M435.838,148.68l-33.89,13.301c-2.004,0.729-2.733,3.644-1.64,6.377 c1.093,2.733,3.644,4.373,5.648,3.644l33.89-13.301c2.004-0.729,2.733-3.644,1.64-6.377 C440.393,149.591,437.842,147.952,435.838,148.68z"
                            />
                            <path
                              style="fill: #6c7678"
                              d="M166.172,456.974l42.636-10.932c6.195-1.64,9.11,10.021,2.915,11.661L169.27,468.27 c-5.831,1.458-8.928-9.657-3.28-11.115L166.172,456.974z"
                            />
                            <g>
                              <path
                                style="fill: #ffe356"
                                d="M401.583,82.54l-21.865,29.153c-1.275,1.64-0.364,4.555,2.004,6.377 c2.369,1.822,5.284,1.822,6.559,0.182l21.865-29.153c1.275-1.64,0.364-4.555-2.004-6.377C405.774,80.9,402.858,80.9,401.583,82.54z"
                              />
                              <path
                                style="fill: #ffe356"
                                d="M458.978,229.762l-35.712-6.742c-2.004-0.364-3.28-3.098-2.733-6.013 c0.547-2.915,2.733-4.92,4.737-4.555l35.712,6.742c2.004,0.364,3.28,3.098,2.733,6.013 C463.169,228.122,460.982,230.127,458.978,229.762z"
                              />
                            </g>
                            <path
                              style="fill: #e4e7ed"
                              d="M90.374,245.25c-1.458,0.547-3.28-0.182-3.826-1.64c-0.547-1.458,0.182-3.28,1.64-3.826l76.891-29.7 c1.458-0.547,3.28,0.182,3.826,1.64c0.547,1.458-0.182,3.28-1.64,3.826L90.374,245.25z"
                            />
                          </svg>
                          <span style="font-size: 13px; margin-left: 4px">Notification: {{ getNotificationcount(day) }}</span>
                        </div>
                        <div>
                          <vs-popup :active.sync="showNotificationModal" :title="'Notification  on ' + currentNotiifcationDay">
                            <div class="popup-content">
                              <div class="list">
                                <ol>
                                  <li
                                    v-for="notification in notificationsForDay"
                                    :key="notification._id"
                                    @click="redirectToNotification(notification._id)"
                                    class="cursor"
                                  >
                                    {{ notification.title }}- On: ({{ formatDate(notification.customDate) }}) Time: ({{ notification.customTime }})
                                    <hr class="line" v-if="index < notificationsForDay.length - 1" />
                                  </li>
                                </ol>
                              </div>
                            </div>
                          </vs-popup>
                        </div>
                      </div>
                    </div>
                    <div class="day-number">
                      {{ day }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </vs-card>
</template>

<script>
import moment, { lang } from "moment";
import axios from "axios";
import { redirect } from "react-router-dom";
import { API } from "@/common/constants";
import api from "@/rest.js";

export default {
  data() {
    return {
      holidays: [],
      selectedTranslation: {
        labels: {
          sunday: "रविवार",
          monday: "सोमवार",
          tuesday: "मंगलवार",
          wednesday: "बुधवार",
          thursday: "गुरुवार",
          friday: "शुक्रवार",
          saturday: "शनिवार",
        },
      },
      currentMonth: moment(),
      panchangData: {},
      festivalsData: {},
      eventsData: {},
      bhaktipromotionData: {},
      notificationsData: {},
      loading: true,
      weekDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      colorx: "#0D2144",
      showModal: false,
      currentDay: null,
      festivalsForDay: [],
      showEventModal: false,
      showFestivalsModal: false,
      showBhaktiModal: false,
      showNotificationModal: false,
      currentEventDay: null,
      currentbhaktiDay: null,
      currentNotiifcationDay: null,
      eventsForDay: [],
      bhaktiForDay: [],
      notificationsForDay: [],
      select: {
        language: "EN",
      },
      languages: [
        { culture: "EN", label: "EN" },
        { culture: "HI", label: "HI" },
        { culture: "MR", label: "MR" },
        { culture: "GU", label: "GU" },
        { culture: "KN", label: "KN" },
        { culture: "TA", label: "TA" },
        { culture: "BN", label: "BN" },
        { culture: "ML", label: "ML" },
        { culture: "TE", label: "TE" },
        { culture: "OR", label: "OR" },
      ],
      amavasyaTranslations: ["Amavasya", "अमावस्या", "અમાવસ્યા", "ಅಮಾವಾಸ್ಯ", "அமாவாசை", "অমাবস্যা", "അമാവാസ്യ", "అమావాస్య", "ଅମାବାସ୍ୟା"],
      ekadashiTranslations: ["Ekadashi", "एकादशी", "એકાદશી", "ಏಕಾದಶಿ", "ஏகாதசி", "একাদশী", "ഏകാദശി", "ఏకాదశి", "ଏକାଦଶୀ"],
      pournimaTranslations: ["Purnima", "पूर्णिमा", "પૂર્ણિમા", "ಪೂರ್ಣಿಮ", "பூர்ணிமா", "পূর্ণিমা", "പൂര്‍ണിമ", "పౌర్ణమి", "ପୂର୍ଣିମା"],
      sundayTranslations: ["Sunday", "रविवार", "રવિવાર", "ಭಾನುವಾರ", "ஞாயிறு", "রবিবার", "ഞായറാഴ്ച", "ఆదివారం", "ରବିବାର"],
    };
  },
  computed: {
    formattedCurrentDate() {
      return this.currentMonth.format("MMMM YYYY");
    },
    monthStart() {
      return this.currentMonth.clone().startOf("month");
    },
    monthEnd() {
      return this.currentMonth.clone().endOf("month");
    },
    adjustedStartDate() {
      let startDay = this.monthStart.day();
      startDay = startDay === 0 ? 6 : startDay - 1;
      return startDay;
    },
    daysInMonth() {
      return Array.from({ length: this.monthEnd.date() }, (_, i) => i + 1);
    },
    dayClass() {
      return (day) => {
        if (this.isTodayPurnima(day)) {
          return "TodayPurnima";
        } else if (this.isTodayAmavasya(day)) {
          return "TodayAmavasya";
        } else if (this.isTodayEkadashi(day)) {
          return "TodayEkadashi";
        } else if (this.isTodaySunday(day) || this.isTodayHoliday(day)) {
          return "TodaySunday";
        } else if (this.isPurnimaSunday(day) || this.isPurnimaHoliday(day)) {
          return "SundayPurnima";
        } else if (this.isSundayAmavasya(day) || this.isHolidayAmavasya(day)) {
          return "HolidayAmavasya";
        } else if (this.isEkadashiSunday(day) || this.isEkadashiHoliday(day)) {
          return "EkadashiSunday";
        } else if (this.isToday(day)) {
          return "active";
        } else if (this.isAmavasya(day)) {
          return "amavasya";
        } else if (this.isPurnima(day)) {
          return "purnima";
        } else if (this.isEkadashi(day)) {
          return "ekadashi";
        } else if (this.isSunday(day) || this.isHoliday(day)) {
          return "sunday";
        }
        return "";
      };
    },
  },
  methods: {
    redirectToFestivals(id) {
      console.log("Redirecting to festivals page with id:", id);
      console.log(this.select.language);
      this.$router.push({ path: "/festival", query: { id, language: this.select.language } });
    },
    redirectToEvents(id, title) {
      console.log("Redirecting to events page with id:", id);
      const edit = true;
      this.$router.push({ path: "/events", query: { id, edit } });
    },
    redirectToBhaktiPromotion(id) {
      console.log("Redirecting to bhakti promotion page with id:", id);
      this.$router.push({ path: "/bhakti-promotion", query: { id, language: this.select.language } });
    },
    redirectToNotification(id) {
      console.log("Redirecting to notification page with id:", id);
      this.$router.push({ path: "/notificationSrv", query: { id, language: this.select.language } });
    },
    bhaktiModal(day) {
      this.currentbhaktiDay = this.currentMonth.clone().date(day).format("DD/MM/YYYY");
      this.bhaktiForDay = this.bhaktipromotionData.filter((bhakti) => {
        const today = this.currentMonth.clone().date(day);
        const start = moment(bhakti.start_date).startOf("day");
        const end = moment(bhakti.end_date).endOf("day");
        return today.isBetween(start, end, null, "[]");
      });
    },
    notificationModal(day) {
      this.currentNotiifcationDay = this.currentMonth.clone().date(day).format("DD/MM/YYYY");
      this.notificationsForDay = this.notificationsData.filter((notification) => {
        const today = this.currentMonth.clone().date(day).startOf("day");
        const start = moment(notification.customDate).startOf("day");
        return today.isSame(start, "day");
      });
    },
    festivalsModal(day) {
      this.currentDay = this.currentMonth.clone().date(day).format("DD/MM/YYYY");
      const today = this.currentMonth.clone().date(day);

      this.festivalsForDay = this.festivalsData.data
        .map((festival) => {
          const startDates = Array.isArray(festival.startDate) ? festival.startDate : [festival.startDate];
          const endDates = Array.isArray(festival.endDate) ? festival.endDate : [festival.endDate];

          for (let i = 0; i < Math.min(startDates.length, endDates.length); i++) {
            const startMoment = moment(startDates[i]);
            const endMoment = moment(endDates[i]);

            if (today.isBetween(startMoment, endMoment, null, "[]")) {
              return { ...festival, matchedStart: startDates[i], matchedEnd: endDates[i] };
            }
          }
          return null;
        })
        .filter((festival) => festival !== null);
    },
    openEventModal(day) {
      this.currentEventDay = this.currentMonth.clone().date(day).format("DD/MM/YYYY");
      const today = this.currentMonth.clone().date(day).startOf("day");
      this.eventsForDay = this.eventsData.data.data.filter((event) => {
        const start = moment(event.startDate).startOf("day");
        const end = moment(event.endDate).endOf("day");
        return today.isBetween(start, end, null, "[]");
      });
      this.showEventModal = true;
    },
    getFestivalscount(day) {
      const today = this.currentMonth.clone().date(day);
      const result = this.festivalsData.data.reduce(
        (acc, festival) => {
          const startDates = Array.isArray(festival.startDate) ? festival.startDate : [festival.startDate];
          const endDates = Array.isArray(festival.endDate) ? festival.endDate : [festival.endDate];

          for (let i = 0; i < Math.min(startDates.length, endDates.length); i++) {
            const startMoment = moment(startDates[i]);
            const endMoment = moment(endDates[i]);

            if (today.isBetween(startMoment, endMoment, null, "[]")) {
              acc.count++;
              if (!acc.firstFestival) {
                acc.firstFestival = festival;
              }
              break;
            }
          }
          return acc;
        },
        { count: 0, firstFestival: null }
      );

      return {
        festivalCount: result.count,
        firstFestival: result.firstFestival || "None",
      };
    },
    getEventcount(day) {
      const today = this.currentMonth.clone().date(day);
      // console.log("Today",today);
      const eventCount = this.eventsData.data.data.reduce((count, event) => {
        // const start = moment(event.startDate);
        // const end = moment(event.endDate);
        const start = moment(event.startDate).startOf("day");
        const end = moment(event.endDate).endOf("day");
        if (today.isBetween(start, end, null, "[]")) {
          count++;
        }
        return count;
      }, 0);
      // console.log(`Number of Events on ${today.format('DD/MM/YY')}: ${eventCount}`);
      // console.log(" ");
      return eventCount;
    },
    getBhakticount(day) {
      const today = this.currentMonth.clone().date(day);
      const bhaktiCount = this.bhaktipromotionData.reduce((count, bhakti) => {
        // const start = moment(event.startDate);
        // const end = moment(event.endDate);
        const start = moment(bhakti.start_date).startOf("day");
        const end = moment(bhakti.end_date).endOf("day");
        if (today.isBetween(start, end, null, "[]")) {
          count++;
        }
        // console.log("Bhakti Promotion",count);
        return count;
      }, 0);
      // console.log(`Number of Events on ${today.format('DD/MM/YY')}: ${bhaktiCount}`);
      // console.log(" ");
      return bhaktiCount;
    },
    getNotificationcount(day) {
      const today = this.currentMonth.clone().date(day);
      const notificationCount = this.notificationsData.reduce((count, notification) => {
        // const start = moment(event.startDate);
        // const end = moment(event.endDate);
        const start = moment(notification.customDate).startOf("day");
        if (today.isSame(start, "day")) {
          count++;
        }
        return count;
      }, 0);
      // console.log(`Number of Notifications on ${today.format('DD/MM/YY')}: ${bhaktiCount}`);
      // console.log(" ");
      return notificationCount;
    },
    t(label) {
      return label;
    },
    isToday(day) {
      const today = moment();
      return today.isSame(this.currentMonth, "month") && today.date() === day;
    },
    isHoliday(day) {
      const formattedDate = this.currentMonth.clone().date(day).format("YYYY-MM-DD");
      return this.holidays.includes(formattedDate);
    },
    isAmavasya(day) {
      return this.amavasyaTranslations.includes(this.getPanchangDetail(day, "Tithi"));
    },
    isPurnima(day) {
      return this.pournimaTranslations.includes(this.getPanchangDetail(day, "Tithi"));
    },
    isEkadashi(day) {
      return this.ekadashiTranslations.includes(this.getPanchangDetail(day, "Tithi"));
    },
    isSunday(day) {
      const dayName = this.getPanchangDetail(day, "Day");
      return this.sundayTranslations.includes(dayName);
    },
    isTodayAmavasya(day) {
      const today = moment();
      return (
        today.isSame(this.currentMonth, "month") && today.date() === day && this.amavasyaTranslations.includes(this.getPanchangDetail(day, "Tithi"))
      );
    },
    isTodayEkadashi(day) {
      const today = moment();
      return (
        today.isSame(this.currentMonth, "month") && today.date() === day && this.ekadashiTranslations.includes(this.getPanchangDetail(day, "Tithi"))
      );
    },
    isTodayPurnima(day) {
      const today = moment();
      return (
        today.isSame(this.currentMonth, "month") && today.date() === day && this.pournimaTranslations.includes(this.getPanchangDetail(day, "Tithi"))
      );
    },
    isTodaySunday(day) {
      const today = moment();
      const dayName = this.getPanchangDetail(day, "Day");
      return today.isSame(this.currentMonth, "month") && today.date() === day && this.sundayTranslations.includes(dayName);
    },
    isTodayHoliday(day) {
      const today = moment();
      return today.isSame(this.currentMonth, "month") && today.date() === day && this.isHoliday(day);
    },
    isEkadashiSunday(day) {
      const dayName = this.getPanchangDetail(day, "Day");
      return this.sundayTranslations.includes(dayName) && this.ekadashiTranslations.includes(this.getPanchangDetail(day, "Tithi"));
    },
    isEkadashiHoliday(day) {
      return this.ekadashiTranslations.includes(this.getPanchangDetail(day, "Tithi")) && this.isHoliday(day);
    },
    isPurnimaSunday(day) {
      const dayName = this.getPanchangDetail(day, "Day");
      return this.sundayTranslations.includes(dayName) && this.pournimaTranslations.includes(this.getPanchangDetail(day, "Tithi"));
    },
    isPurnimaHoliday(day) {
      return this.pournimaTranslations.includes(this.getPanchangDetail(day, "Tithi")) && this.isHoliday(day);
    },
    isHolidayAmavasya(day) {
      const formattedDate = this.currentMonth.clone().date(day).format("YYYY-MM-DD");
      return this.holidays.includes(formattedDate) && this.amavasyaTranslations.includes(this.getPanchangDetail(day, "Tithi"));
    },
    isSundayAmavasya(day) {
      const formattedDate = this.currentMonth.clone().date(day).format("YYYY-MM-DD");
      const dayName = this.getPanchangDetail(day, "Day");
      return this.sundayTranslations.includes(dayName) && this.amavasyaTranslations.includes(this.getPanchangDetail(day, "Tithi"));
    },
    async fetchHolidays() {
      try {
        const year = this.currentMonth.format("YYYY");
        const response = await api.get(API.HOLIDAYS, {
          params: {
            year: year,
            country: "en.indian",
          },
        });
        const monthName = this.currentMonth.format("MMMM");
        this.holidays = response.data[monthName].map((holiday) => moment(holiday.date).format("YYYY-MM-DD"));
      } catch (error) {
        console.error("Failed to fetch holidays:", error);
      }
    },
    previousMonth() {
      this.currentMonth = this.currentMonth.subtract(1, "months").clone();
      this.fetchData();
    },
    nextMonth() {
      this.currentMonth = this.currentMonth.add(1, "months").clone();
      this.fetchData();
    },
    async fetchPanchang() {
      try {
        const year = this.currentMonth.format("YYYY");
        const month = this.currentMonth.format("MMMM");
        const time = moment().format("HH:mm:ss");
        const response = await api.get(API.PANCHANG_PREDICT, {
          params: {
            month_name: month,
            year: year,
            time: "07:00:00",
            lat: 28.6139,
            lon: 77.209,
            app_language: this.select.language,
            data_language: this.select.language,
          },
          headers: {
            "Content-Type": "application/json",
            api_key: "anvl_bharat_cal123",
          },
        });
        this.panchangData = response.data;
      } catch (error) {
        console.error("Failed to fetch panchang:", error);
      }
    },
    async fetchFestivals() {
      try {
        const response = await api.get(API.FESTIVAL, {
          params: {
            language: this.select.language,
          },
        });
        const festivals = { data: response.data.data.filter((festival) => festival.status === true) };
        this.festivalsData = festivals;
      } catch (error) {
        console.error("Failed to fetch festivals:", error);
      }
    },

    async fetchEvents() {
      try {
        const year = this.currentMonth.format("YYYY");
        let allEvents = [];
        console.log(this.select.language);
        const firstResponse = await api.get(API.SOCIAL_EVENTS, {
          params: {
            pageNumber: 1,
            sort: 1,
            language: this.select.language,
            searchKey: "",
            searchValue: "",
            categoryId: "",
            isPrivate: "",
            status: 0,
            sortOrder: -1,
            eventStatus: "APPROVED",
            year: year,
            month: "",
            sortBy: "createdAt",
          },
          headers: {
            "Content-Type": "application/json",
            api_key: "anvl_bharat_cal123",
          },
        });
        const totalPages = firstResponse.data.data.meta.pagination.total_pages;
        allEvents = firstResponse.data;
        for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
          const response = await api.get(API.SOCIAL_EVENTS, {
            params: {
              pageNumber: pageNumber,
              sort: 1,
              language: this.select.language,
              searchKey: "",
              searchValue: "",
              categoryId: "",
              isPrivate: "",
              status: 0,
              sortOrder: -1,
              eventStatus: "APPROVED",
              year: year,
              month: "",
              sortBy: "createdAt",
            },
            headers: {
              "Content-Type": "application/json",
              api_key: "anvl_bharat_cal123",
            },
          });
          allEvents.data.data = allEvents.data.data.concat(response.data.data.data);
        }
        this.eventsData = allEvents;
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
    },

    async fetchBhaktiPromotion() {
      try {
        const response = await api.get(API.GET_PROMOTION_DATA, {
          params: {
            is_active: "active",
            app_language: this.select.language,
          },
        });
        this.bhaktipromotionData = response.data.data;
      } catch (error) {
        console.error("Failed to fetch Bhakti Promotion:", error);
      }
    },

    async fetchNotifications() {
      try {
        const response = await api.get(API.GET_NOTIFICATIONS, {
          params: {
            language: this.select.language,
            status: 1,
          },
        });
        this.notificationsData = response.data;
      } catch (error) {
        console.error("Failed to fetch Notifications:", error);
      }
    },

    async fetchData() {
      this.loading = true;
      await Promise.all([this.fetchHolidays(), this.fetchPanchang(), this.fetchFestivals(), this.fetchBhaktiPromotion()]);
      this.loading = false;
    },
    getFormattedDate(day) {
      return this.currentMonth.clone().date(day).format("DD MMMM YYYY dddd");
    },
    formatDatetime(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getPanchangDetail(day, detailType) {
      const formattedDate = this.getFormattedDate(day);
      if (this.panchangData[formattedDate]) {
        return this.panchangData[formattedDate][0][detailType][0];
      }
      return "N/A";
    },
    getPanchangtime(day, detailType) {
      const formattedDate = this.getFormattedDate(day);
      if (this.panchangData[formattedDate]) {
        const time = this.panchangData[formattedDate][0][detailType][2];
        if (time) {
          return this.formatTime(time);
        }
      }
      return "N/A";
    },
    formatTime(timeString) {
      const date = new Date(timeString);
      return date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
    },
  },
  async mounted() {
    await Promise.all([this.fetchData(), this.fetchEvents(), this.fetchNotifications()]);
    // this.fetchData();
    // this.fetchEvents();
    // this.fetchNotifications();
  },
  watch: {
    "select.language": function () {
      this.fetchEvents();
      this.fetchNotifications();
    },
  },
};
</script>

<style scoped>
#app {
  text-align: center;
  margin: 0 auto;
  max-width: 600px;
}

main {
  padding: 1rem;
}

.current-date {
  margin-top: 20px;
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 20px;
}

.month-navigation {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
  text-align: center;
}

.weekdays {
  margin-bottom: 20px;
}

.weekday-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-radius: 8px;
  background-color: #808080;
  color: black;
  font-weight: bold;
  border: 1px solid transparent;
}

.monday-bg {
  background-color: #ff695f;
  color: white;
}

.days {
  margin-top: 20px;
}

.day-box.empty {
  background-color: transparent;
  border: 1px solid #808080;
  aspect-ratio: 1;
  background-color: white;
  border-radius: 8px;
}

.day-grid {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  border-radius: 8px;
  color: black;
  font-weight: medium;
  aspect-ratio: 1;
  border: #808080 1px solid;
  max-width: 100%;
  max-height: 100%;
  padding: 10px;
  position: relative;
  background-color: white;
}

.day-number {
  font-size: 1.5em;
  font-weight: bold;
  position: absolute;
  left: 10px;
  bottom: 5px;
}

.panchang-details {
  font-size: 0.9em;
  margin-bottom: 10px;
}

.loading-indicator {
  font-size: 1.5em;
  font-weight: bold;
  color: #ff695f;
}

.moon {
  width: 20px;
  height: 20px;
}

.timings {
  display: flex;
  font-size: 0.7rem;
  flex-direction: row;
  font-weight: bold;
  gap: 2px;
  margin-top: 10px;
}

.panchang-info {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  font-size: 0.9rem;
  font-weight: bold;
}

.day-grid.amavasya {
  background-color: #dffbff;
  border: #75cbd7 1px solid;
}

.day-grid.purnima {
  background-color: #ffe2f9;
  border: #e33abe 1px solid;
}
.day-grid.ekadashi {
  background-color: #fffdc6;
  border: #f2d32d 1px solid;
}

.day-grid.sunday {
  background-color: #fff0ef;
  color: black;
  border: #ff695f 1px solid;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ff695f;
  }
}

.day-grid.holiday {
  background-color: #fff0ef;
  color: black;
  border: #ff695f 1px solid;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ff695f;
  }
}

.day-grid.active {
  background-color: #101010;
  color: white;
}

.day-grid.HolidayAmavasya {
  background-color: #dffbff;
  border: #75cbd7 1px solid;
  color: black;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ff695f;
  }
}

.day-grid.TodayAmavasya {
  background-color: #101010;
  color: white;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #dffbff;
  }
}

.day-grid.EkadashiSunday {
  background-color: #fffdc6;
  border: #f2d32d 1px solid;
  color: black;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ff695f;
  }
}

.day-grid.EkadashiHoliday {
  background-color: #fffdc6;
  border: #f2d32d 1px solid;
  color: black;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ff695f;
  }
}

.day-grid.TodayEkadashi {
  background-color: #101010;
  color: white;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #fffdc6;
  }
}

.day-grid.SundayPurnima {
  background-color: #ffe2f9;
  border: #e33abe 1px solid;
  color: black;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ff695f;
  }
}

.day-grid.TodayPurnima {
  background-color: #101010;
  color: white;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ffe2f9;
  }
}

.day-grid.TodaySunday {
  background-color: #101010;
  color: white;
  .day-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #ff695f;
  }
}

.time {
  font-size: 10px;
  margin-left: 10px;
}

.tithi {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.heading {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
}

.grid-info {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}

.event-info {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  font-size: 18px;
}

.modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 600px;
}

.close {
  display: flex;
  justify-content: flex-end;
  font-size: 30px;
  width: 100%;
  cursor: pointer;
}

.list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.cursor {
  cursor: pointer;
  margin-bottom: 10px;
}

.festival {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 10px;
}

.festival-more {
  font-size: 13px;
}

::v-deep .vs-popup--background {
  background-color: transparent !important;
  box-shadow: none !important;
}

::v-deep .vs-popup {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border: 2px solid black !important;
}

.line {
  border: none;
  height: 1px;
  background-color: black;
  margin-top: 10px;
}
</style>
